
<template>
  <div>
    <input
      id="pac-input"
      class="controls"
      type="text"
      placeholder="Type here to start searching..."
    />
    <div id="map"> </div>
  </div>
</template>

<style type="css" scoped>
#map {
  width: 100%;
  height: 300px;
}
.pac-card {
  background-color: #fff;
  border: 0;
  border-radius: 2px;
  box-shadow: 0 1px 4px -1px rgba(0, 0, 0, 0.3);
  margin: 10px;
  padding: 0 0.5em;
  font: 400 18px Roboto, Arial, sans-serif;
  overflow: hidden;
  font-family: Roboto;
  padding: 0;
}

#pac-container {
  padding-bottom: 12px;
  margin-right: 12px;
}

.pac-controls {
  display: inline-block;
  padding: 5px 11px;
}

.pac-controls label {
  font-family: Roboto;
  font-size: 13px;
  font-weight: 300;
}

#pac-input {
  background-color: #fff;
  padding: 5px;
  margin-top: 10px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 300;
  margin-left: 12px;
  padding: 0 11px 0 13px;
  text-overflow: ellipsis;
  width: 300px;
  height: 40px;
}
</style>
<script>

import { Loader } from '@googlemaps/js-api-loader';

export default {
  components: { },
  
  props: {
    apiKey: {
      type: String,
      default: '',
    },
    coordinates: {
      type: Object,
      default: () => ({lat: 18, lng: -77})
    }
  },

  data() {
    return {
      loader: null,
      map: null,
      markers: [],
      timeout: null,
    };
  },

  watch: {
    coordinates:{
      deep: true,
      handler: function(newValue) {
        //update map whenever coordinate changes
        this.debounce(()=>{
          this.setMarker({
            lat: +newValue.lat,
            lng: +newValue.lng,
          }, true);
        }, 2000)

      },
    }   
  },

  beforeDestroy() {
    if(this.timeout) clearTimeout(this.timeout);
  },

  async created() {
    try {
      this.loader = new Loader({
        apiKey: this.apiKey,
        version: "weekly",
        libraries: ["places"]
      });

      await this.loader.load();
      this.map = new google.maps.Map(document.getElementById("map"), {
        center: this.coordinates,
        zoom: 8
      });

      // Create the search box and link it to the UI element.
      const input = document.getElementById("pac-input");
      const searchBox = new google.maps.places.SearchBox(input);

      this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
      // BiaS the SearchBox results towards current map's viewport.
      this.map.addListener("bounds_changed", () => {
        searchBox.setBounds(this.map.getBounds());
      });


      // Listen for the event fired when the user selects a prediction and retrieve
      // more details for that place.
      searchBox.addListener("places_changed", () => {
        const places = searchBox.getPlaces();

        if (places.length == 0) {
          return;
        }


        // For each place, get the icon, name and location.
        const bounds = new google.maps.LatLngBounds();

        places.forEach((place) => {
          if (!place.geometry || !place.geometry.location) {
            console.log("Returned place contains no geometry");
            return;
          }

          this.setMarker(place.geometry.location, false);
          this.$emit('updated', {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          });

          if (place.geometry.viewport) {
            // Only geocodes have viewport.
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
        });

        this.map.fitBounds(bounds);
      });

    } catch (error) {
      console.log('unable to load google map: ', error)
    }
  },

  computed: {
  },

  methods: {

    debounce(func, delay){
      if(this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(()=> {
        func()
      }, delay);
    },

    setMarker(coordinates, setBounds) {
      // Clear out the old markers.
      this.markers.forEach((m) => m.setMap(null) );
      this.markers = [];

      const marker = new google.maps.Marker({
        map: this.map,
        position: coordinates, 
        draggable: true,
      })

      // Create a marker for each place.
      this.markers.push(marker);

      //setup drag event for map marker
      google.maps.event.addListener(marker, 'dragend', (marker) => {
        const latLng = marker.latLng;
        this.$emit('updated', {
          lat: latLng.lat(),
          lng: latLng.lng(),
        });
      }); 
      
      //if set bound is enabled set the bounds, viewport and zoom level of the map
      if(setBounds) {
        const bounds = new google.maps.LatLngBounds();
        const myLatLng = new google.maps.LatLng(coordinates.lat, coordinates.lng);
        bounds.extend(myLatLng);
        this.map.fitBounds(bounds);
        this.map.setZoom(11)
      }
    }

  },
};
</script>

 
